import { useEffect } from 'react'

export function usePageTitle(title: string): void {
  useEffect(() => {
    document.title = `${title} | Derivative Admin`
    return () => {
      document.title = 'Derivative Admin'
    }
  }, [title])
}
